export const permissions = {
    // project settings items
    PROJECT_REPORT_PROPERTIES: "project_report_properties",
    PROJECT_REPORT_TEMPLATES: "project_report_templates",
    PROJECT_TRADES: "trades",
    PROJECT_SYSTEMS: "systems",
    PROJECT_SUBSYSTEMS: "sub_systems",
    PROJECT_RECOMMENDATION_TEMPLATE: "project_recommendation_templates",
    GENERAL: "year_limits",
    EFCI_COLOR: "efci_colors",
    SFCI_COLOR: "sfci_colors",
     ASSET_AVERAGE_CONDITION_INDEX: "asset_average_condition_indexes",
    FCI_COLOR: "fci_colors",
    CHART_CATEGORIES: "chart_categories",
    TERM: "priorities",
    CAPITAL_TYPE: "capital_types",
    MASTER_CAPITAL_TYPE: "capital_type_groups",
    FUNDING_SOURCE: "funding_sources",
    RESPONSIBILITY: "responsibility",
    RECOMMENDATION_ACCEPTABLE_VERBS: "recommendation_acceptable_verbs",
    CATEGORIES: "categories",
    DEPARTMENT: "consultancies",
    PROJECT_ASSET_CONDITION: "asset_conditions",
    BUILDING_TYPES: "building_types",
    MISCELLANEOUS: "miscellaneous",
    RECOMMENDATION_PRIORITIES: "recommendation_priority",
    CRITICALITY: "criticalities",
    CAPITAL_REQUEST: "old_capital_request",
    //modules
    SMART_CHARTS: "smart_charts",
    SMART_CHART_OWN_REPORT: "smart_chart_own_report",
    ASSET_IMPORT_HISTORY: "asset_import_history",
    RECOMMENDATION_SHIFT_CSP: "recommendation_shift_csp",
    SHIFT_CSP_HISTORY: "shift_history",
    DYNAMIC_FIELDS: "recommendation_dynamic_fields",
    DYNAMIC_TABLES: "dynamic_tables",
    CLIENT_DYNAMIC_TABLES: "client_dynamic_tables",
    RECOMMENDATION_FIELD_CONFIG: "recommendation_field_config",
    PROJECT_REVIEWER: "project_reviewer",
    CR_RECOMMENDATIONS: "new_capital_request",
    RECOMMENDATIONS: "recommendations",
    RECOMMENDATION_FULL_DUPLICATE: "recommendation_full_duplicate",
    INITIATIVES: "initiatives",
    SOFT_COSTS: "soft_costs",
    PROJECT_EXPORT_HISTORY: "project_export_history",
    PROJECT_IMPORT_HISTORY: "project_import_history",
    RECOMMENDATION_STATUS: "recommendation_status",
    REGION_IMAGES: "region_images",
    SITE_IMAGES: "site_images",
    BUILDING_IMAGES: "building_images",
    BUILDING_EXECUTIVE_SUMMARY: "building_executive_summary",
    BUILDING_EXECUTIVE_SUMMARY_TEMPLATE: "building_executive_summary_template",
    RECOMMENDATION_IMAGES: "recommendation_images",
    ASSET_IMAGES: "asset_images",
    SMART_CHART_TASK_MANAGER: "smart_chart_task_manager",
    USER_PIVOT_EXPORT: "user_pivot_export",
    MR_RECOMMENDATION: "mobile_recommendations",
    STOP_LIGHT_CONDITIONS: "stop_light_conditions",
    STOP_LIGHT_SYSTEMS: "stop_light_systems",
    MOBILE_ASSETS: "mobile_assets",
    ASSETS: "asset_management",
    SYSTEM_TOP_N_COLORS: "system_top_n_colors",
    GLOBAL_SYSTEM_TOP_N_COLORS: "global_system_top_n_colors",
    PROJECT_SETTINGS: "project_settings",
    LEASE_MANAGEMENT: "lease_management",
    LEASE_COST: "lease_costs",
    FILE_STORAGE: "file_storage",
    CORE_REPORT: "core_report",
    RECOMMENDATION_CSP_YEAR: "recommendation_csp_year",
    PROJECT_SETTINGS_TEMPLATE: "project_settings_template",
    MASTER_PROJECT_SETTINGS_TEMPLATE: "master_project_settings_template",
    SPACE_TYPE: "space_type",
    RECOM_CLIENT_NOTIFICATION: "send_client_user_recom_created_email",
    CR_CLIENT_NOTIFICATION: "send_client_user_cr_created_email",

    RECOMMENDATIONS_SEARCH_AND_REPLACE: "recommendations_search_and_replace",
    CR_RECOMMENDATIONS_SEARCH_AND_REPLACE: "cr_recommendations_search_and_replace",
    MR_RECOMMENDATION_SEARCH_REPLACE: "mobile_recommendations_search_and_replace",
    CLIENT_ASSET_SETTINGS: "client_asset_settings",

    // feature_flag tab — read with the "enable" subitem
    RECOMMENDATION_OTTO_VALIDATION: "recommendation_otto_validation",
    RECOMMENDATION_VERB_VALIDATION: "recommendation_verb_validation",

    CLIENT_MISCELLANEOUS: "client_miscellaneous"
};
